import { Link } from "react-router-dom";
import type { Drama } from "@/mocks/dramas";

interface DramaCardProps {
  drama: Drama;
  index?: number;
}

export default function DramaCard({ drama, index = 0 }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group block animate-fade-up overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
      style={{ animationDelay: `${(index % 8) * 50}ms` }}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-100">
        <img
          src={drama.cover}
          alt={`${drama.title} 剧照`}
          title={`${drama.title} - 泰国双男主剧集推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
          <i className="ri-star-fill text-accent-400"></i>
          {drama.rating.toFixed(1)}
        </span>
        {drama.hot && (
          <span className="absolute right-2 top-2 whitespace-nowrap rounded-full bg-primary-500 px-2 py-0.5 text-xs text-background-50">
            热播
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-transparent p-3">
          <p className="line-clamp-2 text-xs leading-relaxed text-background-100">{drama.shortIntro}</p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="line-clamp-1 font-heading text-base font-bold text-foreground-950">{drama.title}</h3>
        <p className="mt-0.5 line-clamp-1 text-sm text-primary-600">{drama.subtitle}</p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {drama.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {drama.updateDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {(drama.views / 10000).toFixed(1)}万
          </span>
        </div>
      </div>
    </Link>
  );
}